module.exports = __webpack_public_path__ + "img/barcelona.d7c3afca.png";